export const ROOT_ID = 'wptelegram-comments-settings';
